<template>
  <div class="Kanit BGwhite">
    <v-card-text style="margin-top:20px; margin-bottom:0vh; justify-content: center !important;  color: rgb(74, 74, 74) !important;">
      <v-container grid-list-md style="padding-top: 0vh;">
        <v-layout wrap style="padding-top: 0vh;">
          <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;    margin-top: -4vh;">
            <v-container grid-list-md>
              <v-layout wrap style="padding-top: 2vh;">
                <v-flex sm12 md12 lg12 xl12>
                  <v-btn icon flat @click="backlink()">
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                  <h2 style="display: inline-block;margin-left: 1em;">ข้อความตอบกลับอัตโนมัติ</h2>
                </v-flex>
                <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;" :class="(message_reply.length != 0)? '':'mt-30vh'">
                  <v-btn flat small class="buttonedit" @click="showDialog('AddF')">
                    <v-icon>add</v-icon>
                    เพิ่มข้อความตอบกลับ
                  </v-btn>
                </v-flex>
                <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;  overflow:hidden; ">
                  <div style=" min-width: 70%; max-width: 90%;" v-if="message_reply.length != 0">
                    <div class="wrapper">
                      <table class="tabletemplate">
                        <thead>
                          <tr>
                            <th>index</th>
                            <th>ข้อความที่รับ</th>
                            <th>ข้อความตอบกลับ</th>
                            <th>แก้ไข</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(props,index) in message_reply">
                            <td>{{ (index +1) }}</td>
                            <td>{{ props.receive_message }}</td>
                            <td>{{ props.reply_message }}</td>
                            <td>
                              <div style="display: flex;">
                                <v-tooltip left>
                                  <v-btn slot="activator" flat icon @click="showDialogedit(props)" style="margin-right:5px;cursor: pointer;">
                                    <v-icon small>edit</v-icon>
                                  </v-btn>
                                  <span>แก้ไขข้อความ</span>
                                </v-tooltip>
                                <v-tooltip right>
                                  <v-btn slot="activator" flat icon @click="removereplybot(props)" style="cursor: pointer;">
                                    <v-icon small>delete</v-icon>
                                  </v-btn>
                                  <span>ลบข้อความ</span>
                                </v-tooltip>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div style=" min-width: 70%; max-width: 90%; text-align: center;" v-else>
                    <b> ยังไม่มีการเพิ่มข้อความตอบกลับอัตโนมัติ </b>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <AddDialog :dialogAdd="AddF" v-on:closeFriend="closeDialogF"></AddDialog>
    <EditDialog :dialogEditreply="EditF" v-on:closeEditreply="closeDialogF"></EditDialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
import AddDialog from '@/components/managebot/msgreply/Dialog_addreply'
import EditDialog from '@/components/managebot/msgreply/Dialog_editreply'

export default {
  data: () => ({
    token: '',
    name: '',
    message_reply: [],
    botid: '',
    webbackend: '',
    search: '',
    pagination: {},
    selected: [],
    AddF: false,
    EditF: false,

    pages: '',
    tokenbot: '',
    reply_id: '',
    windowWidth: ''
  }),
  components: {
    AddDialog,
    EditDialog
  },
  computed: {
    ...mapState({
      myprofile: 'myprofile',
      botinfo: 'botinfo',
      replyinfo: 'replyinfo',
      editmsgreplyinfo: 'editmsgreplyinfo'
    })
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/dev_msgreply/' + this.botid)
      }
    },
    myprofile () {
      console.log('myProfile')
      this.filename = localStorage.getItem('profilepicture')
    },
    botinfo () {
      if (this.botinfo === 'noneselect') {
        // this.room = 'noneselect'
      } else {
        this.botid = this.$route.params.id
        this.tokenbot = this.$route.params.tokenbot
        this.getreplybot()
      }
    },
    replyinfo () {
      console.log('replyinfo')
      this.getreplybot()
    },
    editmsgreplyinfo () {
      this.reply_id = this.editmsgreplyinfo['id']
    }
  },
  methods: {
    backlink () {
      this.$router.push('/develop/homepage/' + this.botid + '/' + this.tokenbot)
    },
    showDialog (dialog) {
      if (dialog === 'AddF') {
        this.AddF = true
      }
    },
    showDialogedit (item) {
      this.EditF = true
      this.$store.dispatch('changeMsgreply', item)
    },
    closeDialogF (value) {
      this.AddF = value
      this.EditF = value
    },
    getreplybot () {
      this.$http.post(process.env.APImanage + '/getreplybot', {token_bot: this.tokenbot}).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          this.message_reply = response.body.data_reply
          // this.pagination.rowsPerPage = 8
          // if (this.message_reply.length == null) {
          //   this.pages = 0
          // } else {
          //   this.pages = Math.ceil(this.message_reply.length / this.pagination.rowsPerPage)
          // }
        }
      }, (response) => {})
    },
    removereplybot (item) {
      this.$swal({
        title: 'คุณต้องการลบข้อความตอบกลับนี้ใช่ไหม?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่!',
        cancelButtonText: 'ไม่ใช่!',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // console.log(item.id)
          this.$http.post(process.env.APImanage + '/removereplybot', {token_bot: this.tokenbot, id: item.id}).then((response) => {
            // console.log(response.body)
            if (response.body['status'] === 'success') {
              this.$swal(
                'ลบข้อความตอบกลับ!',
                'ลบข้อความตอบกลับสำเร็จ.',
                'success'
              )
              this.$store.dispatch('changeReply', 'removereplybot' + item.id)
              this.$store.dispatch('changeMsgreply', item)
            } else if (response.body['status'] === 'fail') {
              if (response.body['message'] === 'user not found') {
                this.$swal('Bot ID ไม่ถูกต้อง', 'กรุณาตรวจสอบ Bot ID ว่าถูกต้องหรือไม่.', 'error')
              } else if (response.body['message'] === 'id' || 'token_bot') {
                this.$swal('Parameter ไม่ถูกต้อง', 'กรุณาตรวจสอบ Parameter ว่าถูกต้องหรือไม่.', 'error')
              }
            }
          })
        }
      })
    }
  },
  created () {
    this.token = localStorage.getItem('tokenuser')
    this.botid = this.$route.params.id
    this.tokenbot = this.$route.params.tokenbot
    this.webbackend = process.env.API
    this.getreplybot()
  }
}
</script>
<style type="text/css" scoped>

.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

.edit {
  font-weight: 100;
}


.img {
  display: block;
  max-width: 230px;
  max-height: 95px;
  width: auto;
  height: auto;
}

.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}

.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}


.header {
  display: block;
  font-size: 1.17em;
  -webkit-margin-before: 1em;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
  margin: 40px 0 20px;
  padding-left: 20px;
  line-height: 1.3;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  color: black !important;
}

.header::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  width: 0;
  height: 32px;
  border-left: 4px solid #1a76d2;
}


.List_Register {
  margin-bottom: 32px;
  box-sizing: border-box;
}

.List_Register .List_item:last-child {
  border-bottom: none;
}

.List_Register .List_item {
  display: -webkit-flex;
  display: flex;
  padding: 0;
}

.List_Register .List_item:last-child .List_item_header {
  width: 200px;
}

.buttonedit {
  border: solid 1px #DEE5EC !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.BGwhite {
  background-color: white !important;
}


.v-table__overflow {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}

.mt-30vh {
  margin-top: 30vh !important;
}

table {
  border-radius: 10px !important;
  border: #2463af 1px solid;
  border-spacing: 0;
  border-collapse: collapse;
  border-style: hidden;

  width: 100%;
  max-width: 100%;

}

.tabletemplate th {
  color: white;
  background: #2463af;
  /*border-radius: 10px;*/
  border-bottom: 1px solid;
  padding: 5px;
}

.tabletemplate td {
  color: black;
  border: 1px solid #2463af;
  padding: 5px;
}

.wrapper {
  overflow: auto;
  border-radius: 10px;
  border: 1px solid #2463af;
}

tr:nth-child(even) {
  background-color: #e0eeff;
}

</style>



// WEBPACK FOOTER //
// src/components/managebot/msgreply/msg_reply.vue